// @ts-nocheck
/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { MintingClaimAnimationDetails } from '../models/MintingClaimAnimationDetails';
import { MintingClaimAttribute } from '../models/MintingClaimAttribute';
import { MintingClaimImageDetails } from '../models/MintingClaimImageDetails';
import { HttpFile } from '../http/http';

export class MintingClaim {
    'drop_id': string;
    'contract': string;
    'claim_id': number;
    'image_location'?: string | null;
    'animation_location'?: string | null;
    'metadata_location'?: string | null;
    'media_uploading'?: boolean;
    /**
    * Maximum signed 32-bit integer.
    */
    'edition_size'?: number | null;
    'description': string;
    'name': string;
    'image_url'?: string | null;
    'external_url'?: string | null;
    'attributes': Array<MintingClaimAttribute>;
    'image_details'?: MintingClaimImageDetails;
    'animation_url'?: string | null;
    'animation_details'?: MintingClaimAnimationDetails | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "drop_id",
            "baseName": "drop_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "contract",
            "baseName": "contract",
            "type": "string",
            "format": ""
        },
        {
            "name": "claim_id",
            "baseName": "claim_id",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "image_location",
            "baseName": "image_location",
            "type": "string",
            "format": ""
        },
        {
            "name": "animation_location",
            "baseName": "animation_location",
            "type": "string",
            "format": ""
        },
        {
            "name": "metadata_location",
            "baseName": "metadata_location",
            "type": "string",
            "format": ""
        },
        {
            "name": "media_uploading",
            "baseName": "media_uploading",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "edition_size",
            "baseName": "edition_size",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "description",
            "baseName": "description",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "image_url",
            "baseName": "image_url",
            "type": "string",
            "format": ""
        },
        {
            "name": "external_url",
            "baseName": "external_url",
            "type": "string",
            "format": ""
        },
        {
            "name": "attributes",
            "baseName": "attributes",
            "type": "Array<MintingClaimAttribute>",
            "format": ""
        },
        {
            "name": "image_details",
            "baseName": "image_details",
            "type": "MintingClaimImageDetails",
            "format": ""
        },
        {
            "name": "animation_url",
            "baseName": "animation_url",
            "type": "string",
            "format": ""
        },
        {
            "name": "animation_details",
            "baseName": "animation_details",
            "type": "MintingClaimAnimationDetails",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return MintingClaim.attributeTypeMap;
    }

    public constructor() {
    }
}

